/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {StateConfigurationModel} from '../../../shared/status-timeline/models/state-configuration.model';

export const statusTimelineConfiguration: {
    creation: StateConfigurationModel;
    pending: StateConfigurationModel;
    accepted: StateConfigurationModel;
    rejected: StateConfigurationModel;
} = {
    creation: {
            name: '',
            code: 'CREATION',
            color: '#ffffff',
            initialState: true
        },
    pending: {
            name: 'Pending',
            code: 'PENDING',
            color: '#fecb00'
    },
    accepted: {
            name: 'Accepted',
            code: 'ACCEPTED',
            color: '#3e6a3d',
            initialState: false,
            finalState: true,
            intermediateState: true
    },
    rejected: {
            name: 'Rejected',
            code: 'REJECTED',
            color: '#b21014',
            initialState: false,
            finalState: true,
            intermediateState: true
    }
};

